import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notcancelled',
  templateUrl: './notcancelled.component.html',
  styleUrls: ['./notcancelled.component.scss']
})
export class NotcancelledComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
